'use client';

import { Button } from '@/components/ui/button';
import { motion } from 'motion/react';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

const ThemeToggleButton = () => {
  const [mounted, setMounted] = useState(false);
  const { resolvedTheme, setTheme } = useTheme();

  useEffect(() => setMounted(true), []);

  if (!mounted) return <div></div>;

  const toggleTheme = () => setTheme(() => (resolvedTheme === 'dark' ? 'light' : 'dark'));

  return (
    <Button type="button" aria-label="theme toggle button">
      <div className="text-foreground hover:opacity-100 hover:duration-100 hover:after:duration-100" onClick={toggleTheme}>
        {resolvedTheme === 'light' && <motion.span className="i-lucide-sun will-change-transform" transition={{ duration: 0.3 }} />}
        {resolvedTheme === 'dark' && <motion.span className="i-lucide-moon will-change-transform" transition={{ duration: 0.3 }} />}
      </div>
    </Button>
  );
};

export default ThemeToggleButton;
